import pkg from '../../../../package.json';

export const environment = {
  production: true,
  env: 'prod-us',
  version: pkg.version,
  platform: 'webapp',
  baseUrl: 'https://api.glowingbud.com',
  paymentMsUrl: 'https://api.payment.glowingbud.com',
  translateApiUrl: 'https://resources.glowingbud.com/translate',
  s3BucketUrl: 'https://assets.glowingbud.com',
  universalURL: 'https://esimsetup.apple.com/esim_qrcode_provisioning?carddata=',
  previewMode: false,
  appleSocialAuth: {
    clientId: '',
    scope: 'name email',
    redirectURI: '',
    usePopup: true,
    state: 'gbsocialsignup',
  },
  googlePayMerchantId: 'BCR2DN5TR6S43DLF',
};
